<template>
  <div class="section py-0 px-5">
    <div class="tile app-title">
      <p class="subtitle is-6">Inclure les réseaux confrères</p>
    </div>
    <div class="field">
      <b-switch v-model="avecConfreres" type="is-primary"/>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/venteReseauxNumerique-mutation-type';
import gestionErreur from '@/services/general/gestionErreur';

const VenteReseauxNumerique = createNamespacedHelpers('venteReseauxNumerique');

export default {
  name: 'confreres',
  data() {
    return {
    };
  },
  computed: {
    ...VenteReseauxNumerique.mapGetters({
      getAvecConfreres: 'avecConfreres',
    }),
    avecConfreres: {
      get() {
        return this.getAvecConfreres;
      },
      set(value) {
        this.setAvecConfreres(value);
        this.rechercheVentesReseaux();
      },
    },
  },
  methods: {
    ...VenteReseauxNumerique.mapMutations({
      setAvecConfreres: types.SET_AVEC_CONFRERES,
    }),
    ...VenteReseauxNumerique.mapActions({
      actionRechercheReseaux: 'rechercheReseaux',
    }),
    rechercheVentesReseaux() {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.actionRechercheReseaux().then(() => {
        loadingComponent.close();
      }).catch((e) => {
        loadingComponent.close();
        gestionErreur('Erreur lors de la recherche des réseaux numériques liée au confrere', e);
      });
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxNumerique/filtres/confreres.vue